import DonutWithBite from 'components/icons/donut-with-bite';

export const DEFAULT_ICON = DonutWithBite;
